module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/027-american-samoa-980c82f07d6c4157b9b3969f09e607a2.svg";